const deferredCardSlideSelector = 'template[data-seal-card-gallery-slide]';

function hydrateCardGallery(card) {
  if (!(card instanceof Element) || card.dataset.sealCardGalleryHydrated === 'true') return;

  const templates = card.querySelectorAll(deferredCardSlideSelector);
  if (!templates.length) return;

  for (const template of templates) {
    if (!(template instanceof HTMLTemplateElement)) continue;
    template.replaceWith(template.content.cloneNode(true));
  }

  card.dataset.sealCardGalleryHydrated = 'true';
}

function handleCardIntent(event) {
  if (!(event.target instanceof Element)) return;
  hydrateCardGallery(event.target.closest('product-card'));
}

const cardObserver =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries, observer) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            hydrateCardGallery(entry.target);
            observer.unobserve(entry.target);
          }
        },
        { rootMargin: '700px 0px' }
      )
    : null;

function observeDeferredCardGalleries(root = document) {
  if (!cardObserver) return;

  for (const card of root.querySelectorAll('product-card')) {
    if (!card.querySelector(deferredCardSlideSelector)) continue;
    cardObserver.observe(card);
  }
}

function scheduleViewportHydration() {
  const observe = () => observeDeferredCardGalleries();

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(observe, { timeout: 1200 });
  } else {
    window.setTimeout(observe, 250);
  }
}

document.addEventListener('pointerover', handleCardIntent, { capture: true, passive: true });
document.addEventListener('touchstart', handleCardIntent, { capture: true, passive: true });
document.addEventListener('focusin', handleCardIntent, true);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) observeDeferredCardGalleries(event.target);
});

if (document.readyState === 'complete') {
  scheduleViewportHydration();
} else {
  window.addEventListener('load', scheduleViewportHydration, { once: true });
}
